import { Component, OnInit } from '@angular/core';
import { ReportService } from 'src/app/services/report.service';
import { environment } from "src/environments/environment";
import { NgbDateAdapter, NgbDateNativeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { PaysheetManager } from 'src/app/classes/paysheet-manager';

interface operatorList {
  name: string,
  id: number,
}

@Component({
  selector: 'app-receipt',
  templateUrl: './receipt.component.html',
  styleUrls: ['./receipt.component.css'],
  providers: [{provide: NgbDateAdapter, useClass: NgbDateNativeAdapter}]
})
export class ReceiptComponent implements OnInit {

  date1:Date = new Date();
  date2:Date = new Date();
  data:any = {data: [], total: 0};
  all:any = {data: [], total: 0};
  loading:boolean = false;
  total:number = 0;
  operators:operatorList[] = [];
  operator:operatorList = null;

  constructor(private repServ:ReportService, private paysheetManager:PaysheetManager) { 
    this.date1.setDate(this.date1.getDate() - 6);
  }

  ngOnInit() {
    this.search();
  }

  search() {
    this.loading = true;
    this.repServ.paysheetReport(this.date1, this.date2).then(resp => {
      //this.data = this.paysheetManager.calculate(resp.filter(r => r.driver_id != 11));
      this.data = this.paysheetManager.calculate(resp);
      this.all = this.data;
      this.operators = [];

      for(let i = 0; i < this.data.data.length; i++) {
        this.operators.push({
          name: this.data.data[i].info[0].driver_name + ' ' + this.data.data[i].info[0].driver_last_name,
          id: this.data.data[i].info[0].driver_id,
        });
      }

      this.loading = false;
    });
  }

  filterDriver() {
    this.data.data = this.operator ? this.all.data.filter(nom => nom.info[0].driver_id == this.operator.id) : this.all.data;
  }

}
